export default __webpack_public_path__ + "static/media/step_D_UA.42f46172.png";